var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-header"},[_vm._t("title"),_vm._t("note")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }